export default __webpack_public_path__ + "static/media/hearth-detail.50cf610b.svg";